/**
 * "CLI" documentation section (ADR-0074).
 * The `syncanix` command-line tool: install, discovery, and the other commands.
 * Reference pages (config files, env vars, framework support) follow.
 */
import { CLI_COMMANDS_PAGE } from './pages/cli-commands.page';
import { CLI_CONFIG_PAGE } from './pages/cli-config.page';
import { CLI_CONSOLE_PAGE } from './pages/cli-console.page';
import { CLI_FRAMEWORKS_PAGE } from './pages/cli-frameworks.page';
import { CLI_GENERATE_PAGE } from './pages/cli-generate.page';
import { CLI_INIT_PAGE } from './pages/cli-init.page';
import { CLI_OVERVIEW_PAGE } from './pages/cli-overview.page';
import { CLI_REFERENCE_PAGE } from './pages/cli-reference.page';

import type { DocSection } from './types';

export const CLI_SECTION: DocSection = {
  id: 'cli',
  titleKey: 'docs.section.cli.title',
  pages: [
    CLI_OVERVIEW_PAGE,
    CLI_INIT_PAGE,
    CLI_CONSOLE_PAGE,
    CLI_GENERATE_PAGE,
    CLI_COMMANDS_PAGE,
    CLI_CONFIG_PAGE,
    CLI_REFERENCE_PAGE,
    CLI_FRAMEWORKS_PAGE,
  ],
};
